export const DEFAULT_STOREFRONT_COPY: Record<string, string> = {
  "heroEyebrow": "Custom photo pendants",
  "heroHeadline": "Your photo.<br /><em>Your pendant.</em>",
  "heroDescription": "Choose a pendant, upload your photo, and add an engraving if you like.",
  "explore": "Explore the pendants",
  "scroll": "Scroll to the collection",
  "heroFooterEyebrow": "Your photo. Your finish. Your words.",
  "heroFooterTitle": "Create a pendant with your photo.",
  "create": "Create your pendant",
  "previewNote": "Preview your design before ordering",
  "ticker1": "Upload your favorite photo",
  "ticker2": "Choose your pendant and finish",
  "ticker3": "Add an optional engraving",
  "ticker4": "Check your design before ordering",
  "servicePhoto": "Made with your photo",
  "servicePersonal": "Personalized by you",
  "serviceGift": "A gift with meaning",
  "collectionEyebrow": "The collection",
  "collectionTitle": "Choose your pendant.",
  "shopAll": "Shop all pieces",
  "collectionError": "We couldn’t load the collection.",
  "retry": "Try again",
  "collectionEmpty": "Explore all available pieces",
  "stepsEyebrow": "How to customize",
  "stepsTitle": "Make it yours in three steps.",
  "stepsDescription": "Choose your options, add your photo, and check your design before ordering.",
  "stepsCta": "Start with a pendant",
  "step1Title": "Choose your pendant",
  "step1Text": "Pick a shape, finish, and chain.",
  "step2Title": "Add your photo",
  "step2Text": "Add your photo, adjust the crop, and add an engraving where available.",
  "step3Title": "Check your design",
  "step3Text": "Review your design and selected options before adding it to your bag.",
  "galleryEyebrow": "A little inspiration",
  "galleryTitle": "See personalized designs.",
  "galleryCta": "Visit the gallery",
  "galleryFallback": "Made personal",
  "galleryAlt": "Personalized design inspiration",
  "reviewsEyebrow": "From our customers",
  "reviewsTitle": "What our customers say.",
  "contactEyebrow": "Need a hand?",
  "contactTitle": "Need help with your design?",
  "contactDescription": "Ask us about choosing a pendant, preparing your photo, or adding an engraving.",
  "contactCta": "Talk to our team",
  "closingTitle": "Your design, checked by you.",
  "closingText": "See your photo and selected options before adding your pendant to the bag.",
  "loaderLabel": "Preparing your piece",
  "loaderPreview": "Loading preview",
  "loaderBack": "Always close.",
  "customize": "Customize",
  "viewItem": "View item",
  "startingAt": "Starting at",
  "topSeller": "Top seller",
  "heroImageAlt": "Personalized photo pendant",
  "navHome": "Home",
  "navCustomize": "Customize",
  "navGifts": "Gifts",
  "navGallery": "Gallery",
  "navProfile": "Profile",
  "navSignIn": "Sign in",
  "navTrack": "Track",
  "navCart": "Cart",
  "secureCheckout": "Secure checkout",
  "help": "Help",
  "footerExplore": "Explore",
  "footerInfo": "Info",
  "footerContact": "Contact",
  "footerPendants": "Picture Pendants",
  "footerEngraving": "Engraving",
  "footerTrack": "Track Order",
  "footerAbout": "About Us",
  "footerFaq": "FAQ",
  "footerTerms": "Terms of Service",
  "footerSameDay": "Same Day Ready",
  "footerEmail": "Email",
  "footerPhone": "Phone",
  "footerAddress": "Address",
  "footerFallback": "Questions about a piece or your order? We’re here to help.",
  "footerContactCta": "Contact Us",
  "footerFollow": "Follow",
  "footerRights": "All rights reserved",
  "loaderFront": "BP",
  "arBadgeLabel": "AR",
  "arBadgeHint": "3D preview available",
  "viewIn3D": "View in 3D"
};
